import axios from 'axios';

export default axios.create({
	baseURL: 'https://intense-dusk-41426.herokuapp.com/'
});